import React, { useState } from "react";
import styles from "../../assets/styles/Survey/Survey.module.scss";
import { MimaButton, MimaText, MimaTextArea, MimaToastUtil, Modal } from "../../components";
import { Formik } from "formik";
import * as yup from 'yup';
import icon_terrible from "../../assets/img/icon_terrible.svg";
import icon_bad from "../../assets/img/icon_bad.svg";
import icon_neutral from "../../assets/img/icon_neutral.svg";
import icon_good from "../../assets/img/icon_good.svg";
import icon_amazing from "../../assets/img/icon_amazing.svg";
import icon_terrible2 from "../../assets/img/icon_terrible2.svg";
import icon_bad2 from "../../assets/img/icon_bad2.svg";
import icon_neutral2 from "../../assets/img/icon_nuetral2.svg";
import icon_good2 from "../../assets/img/icon_good2.svg";
import icon_amazing2 from "../../assets/img/icon_amazing2.svg";
import { usePostReview } from "../../controllers/SurveyController";
import constant from "../../utils/constant";
import { userStore } from "../../stores";

const Survey = ({ closeModal, title, reviewId }) => {

    const onCloseModal = () => {
        userStore.setReviewId('');
        closeModal();
    }

    const { isLoading, mutateAsync, reset } = usePostReview();

    const onSubmit = async (values) => {
        const payload = {
            reviewId: userStore.reviewId,
            rating: values.rating,
            ...values.review ? { review: values.review } : {}
        }

        try {
            const { status, errorMessage } = await mutateAsync(payload)
            if (status === constant.Success) {
                MimaToastUtil.success({
                    message: "Feedback sent. Thank you. "
                })
                return onCloseModal()
            }
            reset();
            MimaToastUtil.error({
                message: errorMessage
            })
        } catch (e) {

        }
    }

    return (
        <Modal closeModal={closeModal}>
            <>
                <MimaText variant="subtitleBold">
                    Feedback
                </MimaText>
                <Formik
                    initialValues={{
                        rating: "",
                        comment: "",
                    }}
                    onSubmit={onSubmit}
                    validationSchema={() => {
                        return yup.object({
                            rating: yup.number().required('Select Rating'),
                        })
                    }}
                >
                    {({ handleBlur,
                        handleChange,
                        setFieldValue,
                        values,
                        errors,
                        touched,
                        handleSubmit }) => (
                        <>
                            <MimaText align="center" mt={3} mb={3}>
                                {title || "How was your experience using this feature?"}
                            </MimaText>
                            <div className={styles.ratings}>
                                <img src={values.rating === 1 ? icon_terrible2 : icon_terrible} alt="Terrible"
                                    className={values.rating === 1 && styles.ratings_active}
                                    onClick={() => {
                                        setFieldValue("rating", 1);
                                    }} />
                                <img src={values.rating === 2 ? icon_bad2 : icon_bad} alt="Bad"
                                    className={values.rating === 2 && styles.ratings_active}
                                    onClick={() => {
                                        setFieldValue("rating", 2);
                                    }}
                                />
                                <img src={values.rating === 3 ? icon_neutral2 : icon_neutral} alt="Neutral"
                                    className={values.rating === 3 && styles.ratings_active}
                                    onClick={() => {
                                        setFieldValue("rating", 3);
                                    }}
                                />
                                <img src={values.rating === 4 ? icon_good2 : icon_good} alt="Good"
                                    className={values.rating === 4 && styles.ratings_active}
                                    onClick={() => {
                                        setFieldValue("rating", 4);
                                    }}
                                />
                                <img src={values.rating === 5 ? icon_amazing2 : icon_amazing} alt="Amazing"
                                    className={values.rating === 5 && styles.ratings_active}
                                    onClick={() => {
                                        setFieldValue("rating", 5);
                                    }}
                                />
                                {errors.rating && <MimaText>{errors.rating}</MimaText>}
                            </div>

                            <MimaTextArea
                                labelTitle="Kindly drop your suggestions here (Optional)"
                                variant="Comment"
                                placeholder="Please drop your response here"
                                name="comment"
                                value={values.comment}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.comment}
                                touched={touched.comment}
                                mt={3}
                                height={20}
                            />
                            <MimaButton
                                title="Save"
                                type="submit"
                                onClick={handleSubmit}
                                mt={2}
                                width="38"
                                buttonColor="#60607A"
                                loading={isLoading}
                            />
                        </>
                    )}

                </Formik>
            </>
        </Modal>
    )
}
export default Survey;